'use client';

import { Button, type ButtonProps } from '@baseball-near-you/ui';
import posthog from 'posthog-js';
import type { TrackClickEvent } from './types';

export function TrackingButton({
  onClick,
  analyticsEvent,
  ...props
}: ButtonProps & { analyticsEvent?: TrackClickEvent }) {
  return (
    <Button
      {...props}
      onClick={(e) => {
        if (analyticsEvent) {
          posthog.capture(analyticsEvent.name, analyticsEvent.eventProperties);
        }
        onClick?.(e);
      }}
    />
  );
}
